import { FieldValues, useForm } from 'react-hook-form';
import { Input } from '@/components/form';
import Icons from '@/const/icons';
import { Icon } from '@/components/common';
import { useChatMessages } from '@/hooks';
import clsx from 'clsx';

export const ChatInput: React.FC = () => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { isValid },
	} = useForm();

	const rules = {
		'user-message': {
			required: {
				value: true,
				message: '',
			},
		},
	};
	const { addChatMessages, chatMessages, isLoading } = useChatMessages();

	const handleSubmitMessage = async (data: FieldValues): Promise<void> => {
		reset({
			'user-message': '',
		});
		await addChatMessages(data['user-message'], 'user');
	};

	const handleSendFirstCommand = (): void => {
		if (chatMessages.length === 1 && !isLoading) {
			// addChatMessages('conversation-start', 'command');
		}
	};

	return (
		<form className="w-full" onSubmit={handleSubmit(handleSubmitMessage)}>
			<div className="flex items-center gap-1 border-t border-t-opacity-primary pt-2 relative">
				<Input
					name="user-message"
					register={register}
					classNameInput="py-2 px-4 pr-10 !h-9 text-sm w-full"
					className="flex-1"
					onFocus={handleSendFirstCommand}
					rules={rules['user-message']}
				/>
				<button
					type="submit"
					className={clsx(
						'absolute right-4 top-[40%] text-green-60 w-5 h-6 cursor-pointer',
						{
							'!cursor-not-allowed': !isValid,
						}
					)}
					disabled={isLoading || !isValid}
				>
					<Icon src={Icons.send} className="cursor-pointer" />
				</button>
			</div>
		</form>
	);
};
